import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

import { OrganizationDeletion } from './organization-deletion';

export function PrivacySettingsSection() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Data requests</CardTitle>
        <CardDescription>
          For a copy of your data, changes to your details or a deletion
          request, email our privacy team.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <p className="text-sm">
          <a
            href="mailto:privacy@borradh.io"
            className="underline underline-offset-4 hover:text-primary"
          >
            privacy@borradh.io
          </a>
        </p>
        <OrganizationDeletion />
      </CardContent>
    </Card>
  );
}
